import apiCall from "./apiCall";

export default async function ResetPasswordAPI(email) {
    const URL = process.env.REACT_APP_API_URL+'/api/requestpasswordreset';
    const BODY = {email: email}
    const data = await apiCall('POST', URL, BODY);
    return data;
};